import { render, staticRenderFns } from "./GroupsPushCombine.vue?vue&type=template&id=6fe8516f&"
import script from "./GroupsPushCombine.vue?vue&type=script&lang=ts&"
export * from "./GroupsPushCombine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports